import { closestCenter, pointerWithin, type CollisionDetection } from '@dnd-kit/core';

const LAYOUT_COL_MARKER = '-layout-col-';

/** Sortable id for the column shell wrapper (column reorder), not a block drop target. */
export function isLayoutColSortableId(id: string): boolean {
  return id.startsWith('columns-') && id.includes(LAYOUT_COL_MARKER);
}

/**
 * Collision detection for the page block editor.
 * Column shells use sortable ids for column reorder; when dragging blocks those shells
 * must not win over nested blocks or column droppables (see movePageBlock).
 */
export const pageBlockCollisionDetection: CollisionDetection = args => {
  const activeId = String(args.active.id);
  const draggingColumnLayout = isLayoutColSortableId(activeId);

  if (draggingColumnLayout) {
    const layoutColHits = closestCenter({
      ...args,
      droppableContainers: args.droppableContainers.filter(c =>
        isLayoutColSortableId(String(c.id)),
      ),
    });
    if (layoutColHits.length > 0) return layoutColHits;
    return closestCenter(args);
  }

  const withoutColumnShells = (ids: { id: string | number }[]) =>
    ids.filter(c => !isLayoutColSortableId(String(c.id)));

  const pointerHits = withoutColumnShells(pointerWithin(args));
  if (pointerHits.length > 0) return pointerHits;

  const centerHits = withoutColumnShells(closestCenter(args));
  if (centerHits.length > 0) return centerHits;

  return closestCenter(args);
};
